import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { bookService } from '../../../services/book.service';
import './ShareBookModal.css';

const ShareBookModal = ({ isOpen, onClose, onShare, userId }) => {
  const [books, setBooks] = useState([]);
  const [selectedBook, setSelectedBook] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSharing, setIsSharing] = useState(false);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const userLibrary = await bookService.getUserLibrary(userId);
        setBooks(userLibrary);
      } catch (error) {
        console.error('Error fetching books:', error);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen && userId) {
      setLoading(true);
      fetchBooks();
    }
  }, [isOpen, userId]);

  const handleShare = async () => {
    if (selectedBook) {
      setIsSharing(true);
      try {
        await onShare(selectedBook);
        onClose();
      } catch (error) {
        console.error('Error sharing book:', error);
      } finally {
        setIsSharing(false);
      }
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setSelectedBook(null);
      setIsSharing(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <motion.div
      className="modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="modal-content"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
      >
        <div className="modal-header">
          <h2>Share Book</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="loading">Loading books...</div>
          ) : books.length === 0 ? (
            <div className="no-books">No books found in your library. Add some books to share!</div>
          ) : (
            <div className="books-list">
              {books.map(book => (
                <div
                  key={book.libraryId}
                  className={`book-item ${selectedBook?.libraryId === book.libraryId ? 'selected' : ''}`}
                  onClick={() => setSelectedBook(book)}
                >
                  <div className="book-info">
                    <h3>{book.title}</h3>
                    <p className="book-author">by {book.author}</p>
                    <p className="book-status">Status: {book.status}</p>
                    <p className="book-progress">Progress: {book.progress} / {book.pages} pages</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button 
            className="cancel-button" 
            onClick={onClose}
            disabled={isSharing}
          >
            Cancel
          </button>
          <button
            className="share-button"
            onClick={handleShare}
            disabled={!selectedBook || isSharing}
          >
            {isSharing ? 'Sharing...' : 'Share Book'}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ShareBookModal; 